import { render, staticRenderFns } from "./OverlayOrderUpdate.vue?vue&type=template&id=195c3a0a"
import script from "./OverlayOrderUpdate.vue?vue&type=script&lang=js"
export * from "./OverlayOrderUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports